import { render } from "./DistributorCard.vue?vue&type=template&id=655a0752"
import script from "./DistributorCard.vue?vue&type=script&lang=js"
export * from "./DistributorCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/packages/usg_theme/vueproject/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__